import { FeedbackCardContainer } from '@yes.technology/react-toolkit'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../asset/css/default.css'

import { useHandleLanguage } from './hooks'
import Loading from './Loading'
import AuthenticationRenewal from './AuthenticationRenewal'
import RedirectToLogin from './RedirectToLogin'
import EnvironmentAlert from './EnvironmentAlert'
import NetworkDetector from './NetworkDetector'
import Router from './Router'
import useToken from './useToken'
import useWorkflow from './Workflow'
import { useAppSelector } from 'state/store'

global.jQuery = require('jquery')
require('bootstrap')

const HelloYes = () => {
  const isLoading = useAppSelector((state) => state.api.isPending)

  useHandleLanguage()
  useToken()
  useWorkflow()

  return (
    <>
      <Loading active={isLoading} />
      <AuthenticationRenewal />
      <RedirectToLogin />
      <EnvironmentAlert environment={window.waEnv} />
      <NetworkDetector />
      <Router />
      <FeedbackCardContainer />
    </>
  )
}

export default HelloYes
